import { HttpClient,HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, catchError, publishReplay, refCount } from 'rxjs/operators';
import { EMPTY, Observable } from 'rxjs';
import { HandleError, HttpErrorHandlerService } from '../http/http-error-handler.service';
import { ApiConfigurationService } from './api-configuration.service';
import { GuiFlowService } from '../__gui/gui-flow.service';

const httpOptions = {

  headers: new HttpHeaders({
    'Content-Type':  'application/json',
    'Authorization': 'my-auth-token'
  })
};

@Injectable({
  providedIn: 'root'
})
export class ApiConnectorService {

  // Error handling
  private handleError: HandleError;
  cache = {};
  // API URL
  private apiURL;
  private webPageDomain = 'voyjaleas.com';
  private httpPrefix = 'https://';
  lastObjectInserted;

  constructor(private http: HttpClient, httpErrorHandler: HttpErrorHandlerService,private guiFlow: GuiFlowService,private apiConfig: ApiConfigurationService) { 
    this.handleError = httpErrorHandler.createHandleError('ApiEmailService');
  }

  getResponse(data){
    return data; 
  }
  
  voyjaleasApiRequest(queryName: string, queryParam1: string,queryParam2: string,queryParam3: string, queryParam4: string,NewElement:any){

    let phpFileName = '';
    let config = this.getQueryIdConfig(queryName);
    this.apiURL  = config['requestUrl'];
    let queryParam = '?queryId=' + queryName;
    queryParam1 ? queryParam = queryParam + '&queryParam1=' + queryParam1 : queryParam = queryParam;
    queryParam2 ? queryParam = queryParam + '&queryParam2=' + queryParam2 : queryParam = queryParam;
    queryParam3 ? queryParam = queryParam + '&queryParam3=' + queryParam3 : queryParam = queryParam;
    queryParam4 ? queryParam = queryParam + '&queryParam4=' + queryParam4 : queryParam = queryParam;

    ///
    phpFileName = config['fileName'];
    // READY URL
    this.apiURL = this.apiURL + phpFileName + queryParam;

    if(config['xhrOp'] == 'get'){
      return this.http.get<any>(this.apiURL)
      .pipe(map(data => this.getResponse(data)));
    }else

    if(config['operation'] == 'put'){
      !NewElement? NewElement = { test: null} : null;
      return this.http.put<any>(this.apiURL, NewElement, httpOptions)
      .pipe(
        catchError(this.handleError('updatingNewElement', NewElement))
      );
    }else{
      this.guiFlow.openSimpleSnackBar('ERROR en voyjaleasApiRequest por el objeto config',null)
      return EMPTY;
    }
  }

  /// SIMPLIFIED VERSION OF API
  simpleQueryId( queryId: string,queryParam1: string,queryParam2: string,queryParam3: string,queryParam4: string,queryParam5: string): Observable<any> {
    let phpFileName = '';
    let apiURL  = this.httpPrefix + this.getDomain(queryId) + '/' + this.getApiAssigned(queryId) + '/get/';
    let queryParam = '?queryId='+queryId;

    if(queryId.toLocaleLowerCase() == 'get'){
      queryParam1 !== null? queryParam = queryParam + '&table=' + queryParam1 : queryParam = queryParam;
    }else{
      queryParam1 !== null? queryParam = queryParam + '&queryParam1=' + queryParam1 : queryParam = queryParam;
    }

    queryParam2 !== null? queryParam = queryParam + '&queryParam2=' + queryParam2 : queryParam = queryParam;
    queryParam3 !== null? queryParam = queryParam + '&queryParam3=' + queryParam3 : queryParam = queryParam;
    queryParam4 !== null? queryParam = queryParam + '&queryParam4=' + queryParam4 : queryParam = queryParam;
    queryParam5 !== null? queryParam = queryParam + '&queryParam5=' + queryParam5 : queryParam = queryParam;

    phpFileName = 'queryHandler.php';
    apiURL = apiURL + phpFileName + queryParam;
    let force = false;

    force = true;


    // Proceed
    this.sendRequestToServer(apiURL,queryId,force);
    return this.cache[queryId];
  }

  sendRequestToServer(url,label,force){

    if (!this.cache[label] || force) {
      this.cache[label] = this.http.get(`${url}`).pipe(
          map(data => data),
          publishReplay(1), // this tells Rx to cache the latest emitted
          refCount() // and this tells Rx to keep the Observable alive as long as there are any Subscribers
      );
    }
  }

  newDynamicApiRequest(httpMethod: string, table: string, NewElement: any): Observable<any> {

    let phpFileName = '';
    httpMethod = httpMethod.toLocaleLowerCase();

    NewElement? this.lastObjectInserted = NewElement : this.lastObjectInserted = null;

    let apiUrl  = this.httpPrefix + this.getApiDomain() + '/' + this.getProjectApi() + '/' + httpMethod + '/';
    const queryParam = '?table=' + table;
    switch (httpMethod) {
      
      case 'post':
        phpFileName = 'create.php' + queryParam;
        apiUrl = apiUrl + phpFileName;
        return this.http.post<any>(apiUrl, NewElement, httpOptions)
          .pipe(
            catchError(this.handleError('addingNewElement', {KO:{
              message: 'Error on create',
              code: '19'
            }}))
          );

      default: break;
    }
  }

  executePutApiRequest(queryName: string, queryParam1: string,queryParam2: string,queryParam3: string, queryParam4: string,NewElement:any){
    let phpFileName = '';
    let config = this.getQueryIdConfig(queryName);
    this.apiURL  = config['requestUrl'];
    let queryParam = '?queryId=' + queryName;
    queryParam1 ? queryParam = queryParam + '&queryParam1=' + queryParam1 : queryParam = queryParam;
    queryParam2 ? queryParam = queryParam + '&queryParam2=' + queryParam2 : queryParam = queryParam;
    queryParam3 ? queryParam = queryParam + '&queryParam3=' + queryParam3 : queryParam = queryParam;
    queryParam4 ? queryParam = queryParam + '&queryParam4=' + queryParam4 : queryParam = queryParam;

    phpFileName = config['fileName'];
    // READY URL
    this.apiURL = this.apiURL + phpFileName + queryParam;
    return this.http.put<any>(this.apiURL, NewElement, httpOptions)
      .pipe(
        catchError(this.handleError('updatingNewElement', NewElement))
      );


      /* let phpFileName = '';
    let config = this.getQueryIdConfig(queryName);
    this.apiURL  = config['requestUrl'];
    let queryParam = '?queryId=' + queryName;
    queryParam1 ? queryParam = queryParam + '&queryParam1=' + queryParam1 : queryParam = queryParam;
    queryParam2 ? queryParam = queryParam + '&queryParam2=' + queryParam2 : queryParam = queryParam;
    queryParam3 ? queryParam = queryParam + '&queryParam3=' + queryParam3 : queryParam = queryParam;
    queryParam4 ? queryParam = queryParam + '&queryParam4=' + queryParam4 : queryParam = queryParam;

    ///
    phpFileName = config['fileName'];
    // READY URL
    this.apiURL = this.apiURL + phpFileName + queryParam;


    if(config['operation'] == 'get'){
      return this.http.get<any>(this.apiURL)
      .pipe(map(data => this.getResponse(data)));
    }

    if(config['operation'] == 'put'){
      !NewElement? NewElement = { test: null} : null;
      return this.http.put<any>(this.apiURL, NewElement, httpOptions)
      .pipe(
        catchError(this.handleError('updatingNewElement', NewElement))
      );
    } */

  }

  executeApiRequest(queryName: string, queryParam1: string,queryParam2: string,queryParam3: string,cacheLabel: string,force: boolean){
    let phpFileName = '';

    this.apiURL  = this.httpPrefix + this.getApiDomain() + '/' + this.getApiAssigned(queryName) + '/get/';
    let queryParam;

    if(queryName && queryName.toLowerCase() == 'get' ){
      queryParam = '?queryId=GET';
      queryParam1? queryParam = queryParam + '&tableName1=' + queryParam1 : queryParam;

    }else if(queryName && queryName.toLowerCase() == 'put' ){
      phpFileName = 'update.php';
      let queryParam = '?table=' + 'contactForm';
      this.apiURL  = this.httpPrefix + this.webPageDomain + '/' + this.getApiAssigned(queryName) + '/' + 'put' + '/dynamic/';
      this.apiURL = this.apiURL + phpFileName + queryParam+ '&id='+queryParam1;

      /* return this.http.put<any>(this.apiURL, this.newVoyJaleasContactFormEntry, httpOptions)
        .pipe(
          catchError(this.handleError('updatingElement', {}))
        ); */
       // this.newVoyJaleasContactFormEntry.messageRead = true;
        this.http.put<any>(this.apiURL, {messageRead: true})
        .subscribe({
            next: data => {
                //
            },
            error: error => {
                //this.errorMessage = error.message;
                console.error('There was an error!', error);
            }
        });
    }else{
      queryParam = '?queryId='+queryName;
      queryParam1 ? queryParam = queryParam + '&queryParam1=' + queryParam1 : queryParam = queryParam;
    } 
    
    // EMAILS
    if(queryName!= 'readEmail'){
        // Other params
      queryParam2 ? queryParam = queryParam + '&queryParam2=' + queryParam2 : queryParam = queryParam;
      queryParam3 ? queryParam = queryParam + '&queryParam3=' + queryParam3 : queryParam = queryParam;

      phpFileName = 'myapi.php';
      // READY URL
      this.apiURL = this.apiURL + phpFileName + queryParam;
      force = true;

      if(cacheLabel){
        this.sendRequestToServer(this.apiURL,cacheLabel,force)
        return this.cache[cacheLabel];
      }else{
        if(queryName == 'get'){
          this.sendRequestToServer(this.apiURL,queryParam1,force);
          return this.cache[queryParam1];
        }else{
          this.sendRequestToServer(this.apiURL,queryName,force);
          return this.cache[queryName];
        }
      }
    }
    
  }

  createHistoric(data,operation){
    this.newDynamicApiRequest('post', 'historic', JSON.stringify(data))
    .subscribe(
      (response) => {
        console.log('Historic created successfully');
      },
      (error) => {
       console.log('Error creating historic.' + operation)
      }
    );
  }

  getProjectApi(){
    return 'api-dashboard';
  }

  getApiDomain(){
    return 'dashboard.voyjaleas.com';
  }

  getDomain(queryId){
    switch(queryId){
      // NEW API 2025 - HOSTINGER
      case 'get':
      case 'GET':
      case 'getBachLegalContracts':
      case 'cotizaciones':
      case 'getStepsForChecklistItem':
        return 'dashboard.voyjaleas.com';
      default:
          return 'dashboard.voyjaleas.com'
    }
  }

  getApiAssigned(queryId){
    switch(queryId){
      // NEW API 2025 - HOSTINGER
      case 'get':
      case 'GET':
      case 'getBachLegalContracts':
      case 'cotizaciones':
      case 'updateFollowUpStatus':
      case 'getAnswersXQuestion':
      case 'getStepsForChecklistItem':
        return 'api-dashboard';
      //
      default:
        return 'default';
    }
  }

  getConfigRelated(id){
    let config = {};
    switch(id){
      // Latest
      case 'new':
          config['fileName'] = 'dashboardApi.php';
          config['domain'] = 'dashboard.voyjaleas.com';
          config['apiUrl'] = 'api-dashboard';
          config['operation'] = 'get';
          config['xhrOp'] = "get";
          config['requestUrl'] = this.httpPrefix + config['domain'] + '/' +  config['apiUrl'] + '/'+ config['operation']+'/';
        return config;  
      case 'newLogin':
          config['fileName'] = 'login.php';
          config['domain'] = 'dashboard.voyjaleas.com';
          config['apiUrl'] = 'api-dashboard';
          config['operation'] = 'login';
          config['xhrOp'] = "get";
          config['requestUrl'] = this.httpPrefix + config['domain'] + '/' +  config['apiUrl'] + '/'+ 'post' + '/' + config['operation']+'/';
        return config;
      case 'activeDeactivateClientTool':
        config['fileName'] = 'dashUpdate.php';
        config['domain'] = 'dashboard.voyjaleas.com';
        config['apiUrl'] = 'api-dashboard';
        config['operation'] = 'put';
        config['xhrOp'] = "put";
        config['requestUrl'] = this.httpPrefix + config['domain'] + '/' +  config['apiUrl'] + '/'+ config['operation']+'/';
        return config;
      // new 2025
      case 'new25':
        config['fileName'] = 'myapi.php';
        config['domain'] = 'voyjaleasdash.ipnetcostarica.com';
        config['apiUrl'] = 'api-dashboard';
        config['operation'] = 'get';
        config['xhrOp'] = "get";
        config['requestUrl'] = this.httpPrefix + config['domain'] + '/' +  config['apiUrl'] + '/'+ config['operation']+'/';
        return config;
      case 'new25b':
          config['fileName'] = 'budgetApi.php';
          config['domain'] = 'voyjaleasdash.ipnetcostarica.com';
          config['apiUrl'] = 'api-dashboard';
          config['operation'] = 'get';
          config['xhrOp'] = "get";
          config['subfolder'] = "budgets";
          config['requestUrl'] = this.httpPrefix + config['domain'] + '/' +  config['apiUrl'] + '/'+ config['subfolder']+'/';
          return config;
        case 'put25':
          config['fileName'] = 'update.php';
          config['domain'] = 'voyjaleasdash.ipnetcostarica.com';
          config['apiUrl'] = 'api-dashboard';
          config['operation'] = 'put';
          config['xhrOp'] = "put";
          config['subfolder'] = "put";
          config['requestUrl'] = this.httpPrefix + config['domain'] + '/' +  config['apiUrl'] + '/'+ config['subfolder']+'/';
          return config;
          // NEW 2025
        case 'dashboard_api':
            config['fileName'] = 'myapi.php';
            config['domain'] = 'voyjaleasdash.ipnetcostarica.com';
            config['apiUrl'] = 'api-dashboard';
            config['operation'] = 'get';
            config['xhrOp'] = "get";
            config['requestUrl'] = this.httpPrefix + config['domain'] + '/' +  config['apiUrl'] + '/'+ config['operation']+'/';
            return config;
        case 'new25final':
          config['fileName'] = 'queryHandler.php';
            config['domain'] = 'dashboard.voyjaleas.com';
            config['apiUrl'] = 'api-dashboard';
            config['operation'] = 'get';
            config['xhrOp'] = "get";
            config['requestUrl'] = this.httpPrefix + config['domain'] + '/' +  config['apiUrl'] + '/'+ config['operation']+'/';
            return config;
      case 'new25finalPut':
          config['fileName'] = 'update.php';
            config['domain'] = 'dashboard.voyjaleas.com';
            config['apiUrl'] = 'api-dashboard';
            config['operation'] = 'put';
            config['xhrOp'] = "put";
            config['requestUrl'] = this.httpPrefix + config['domain'] + '/' +  config['apiUrl'] + '/'+ config['operation']+'/';
            return config;
      default:
        debugger
        return config = {
          // TODO
        }
    }
  }

  getQueryIdConfig(queryId){
    let config = {};
    switch(queryId){
      case 'activeDeactivateClientTool':
        return this.getConfigRelated('activeDeactivateClientTool');
      case 'getClientTools':
      case 'getClientAppList':
      
        return this.getConfigRelated('new');
      case 'cookiesDashLogin':
      case 'loginDash':
        return this.getConfigRelated('newLogin');
      // NEW 2025
      case 'cotizaciones':

      case 'getClientUtilities':
      case 'getThisClientApps':
      case 'getOmnibusContracts':
      case 'getBachLegalContracts':
      case 'get':
      case 'GET':
      case 'clientChecklists':
      case 'getStepsForChecklistItem':
        return this.getConfigRelated('new25');
      case 'updateClientDetails':
        return this.getConfigRelated('put25');
      case 'getCotizacion':
        return this.getConfigRelated('new25b');
        //

      // FINAL MIGRATION AGOSTO_2025
      case 'getClientDetails':
      case 'getCotizacionByToken':
      case 'getCotizacionByClientId':
      case 'getPackDetails':
      case 'getInteractionXclient':
        return this.getConfigRelated('new25final');
      case 'updateFollowUpStatus':
        return this.getConfigRelated('new25finalPut');
      default:
        console.log('No hay un endpoint configurado');
        this.guiFlow.openSimpleSnackBar('No hay un endpoint configurado', queryId);
        return config = {
          // TODO
        }
    }
  }

  // Usage
  //const data = await this.getXhr(url).toPromise();
  getXhr(url){
    return this.http.get(url)
    //return this.http.get(url, { params }); // Returns an Observable
  }

  deleteOrder(id){
    this.http.get('https://dashboard.voyjaleas.com/api-dashboard/delete/delete.php', {
      params: {
        queryId: 'deleteById',
        queryParam1: id,
        tableName: 'shopifyOrder'
      }
    }).subscribe(res => {
      console.log(res);
    });
  }

  newSimpleGet(queryParam1,cacheLabel = null){

    let phpFileName = '';
    let queryName = 'get';
    this.apiURL  = this.httpPrefix + this.getApiDomain() + '/' + this.getApiAssigned(queryName) + '/get/';
    let queryParam;

    if(queryName && queryName.toLowerCase() == 'get' ){
      queryParam = '?queryId=GET';
      queryParam1? queryParam = queryParam + '&table=' + queryParam1 : queryParam;

    }

      let force = true;
      phpFileName = 'queryHandler.php';
      // READY URL
      this.apiURL = this.apiURL + phpFileName + queryParam;
      force = true;

      if(cacheLabel){
        this.sendRequestToServer(this.apiURL,cacheLabel,force)
        return this.cache[cacheLabel];
      }else{
        if(queryName == 'get'){
          this.sendRequestToServer(this.apiURL,queryParam1,force);
          return this.cache[queryParam1];
        }else{
          this.sendRequestToServer(this.apiURL,queryName,force);
          return this.cache[queryName];
        }
      }
    }
}
